import BaseService from './base.service';

export default class UserService extends BaseService {
    constructor(ctx) {
        super(ctx);
    }

    getTopUserList = query => {
        return this.get('/user', query);
    };

    getUserList = (query = {}) => {
        return this.get('/user/list', query);
    };

    getCalendarList = (query = {}) => {
        return this.get('/user/calendar', query);
    };

    getUserDetail = (id, query = {}) => {
        return this.get(`/user/detail/${id}`, query);
    };

    getUserOptions = (query = {}) => {
        return this.get('/user/get-options', query);
    };
}
